<script setup>
import { inject, watch } from 'vue'
import HamburgerSvg from '@/assets/hamburger.svg?skipsvgo'
import CloseSvg from '@/assets/close.svg?skipsvgo'

const { toggle, open } = inject('main-navigation', { toggle: () => {} })
const active = defineModel('active', { type: Boolean, default: true })

watch(open, (open) => { active.value = open }, { immediate: true })
</script>

<template>
    <i
        :aria-pressed="active ? 'true' : 'false'"
        :class="['menu-button', { 'menu-button--active': active }]"
        @click="toggle"
        role="button"
    >
        <HamburgerSvg v-if="!active" />
        <CloseSvg v-else />
    </i>
</template>

<style lang="scss">
@use "@bam/scss" as *;

:root {
    @include v((
        menu-button-color: #{v(color-white)},
        menu-button-color--hover: #{v(color-primary)},
    ))
}

.menu-button {
    cursor: pointer;
    color: v(menu-button-color);
    transition: color v(duration-default) v(easing-default);

    @include hover {
         color: v(menu-button-color--hover);
    }

    svg {
        @include svg-auto-color;
        color: inherit;
    }
}
</style>
